<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary m-r-24">Campaigns</div>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            class="m-auto p-t-0 p-b-0 d-flex"
          >
            <v-text-field
              id="search"
              class="search-input"
              v-model="word"
              label="Search campaign"
              prepend-inner-icon="fa-search"
              persistent-hint
              rounded
              singleLine
              clearable
              clear-icon="fa-times"
              dense
              hide-details
              @click:clear="clearWord"
              v-on:keydown.enter.exact.prevent
              v-on:keydown.enter.exact="searchWord"
            ></v-text-field>
            <div class="d-flex align-center m-l-15">
              <div class="text-label m-r-10">
                Show only today’s and future campaigns
              </div>
              <v-switch
                v-model="search.showActive"
                inset
                dense
                x-small
                hide-details
              ></v-switch>
            </div>
            <v-btn
              id="new-campaign"
              class="m-auto"
              color="btn-primary"
              @click="dialog = true"
            >
              New
            </v-btn>
          </v-col>
          <!-- <v-col cols="12" sm="4" md="4" lg="4" class="d-flex p-t-0 p-b-0">
            <v-select
              id="select-status"
              class="m-auto m-r-24"
              v-model="search.status"
              :items="statusLists"
              item-text="text"
              item-value="value"
              label="Status"
              dense
              hide-details
              clearable
              clear-icon="fa-times"
            >
              <template v-slot:item="{ item }">
                <div class="v-list-item__content">
                  <div class="v-list-item__title d-flex">
                    <v-icon class="m-r-10" small>
                      {{ item.icon }}
                    </v-icon>
                    {{ item.text }}
                  </div>
                </div>
              </template>
            </v-select>
            <v-btn
              id="new-campaign"
              class="m-auto"
              color="btn-primary"
              @click="dialog = true"
              >New</v-btn
            >
          </v-col> -->
        </v-row>
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :loading="loading"
        loading-text="Loading..."
        :headers="headers"
        :items="campaigns"
        :page.sync="search.page"
        :sort-by.sync="search.sortBy"
        :sort-desc.sync="search.sortDesc"
        :items-per-page="9999"
        hide-default-footer
        fixed-header
        must-sort
        class="elevation-1"
      >
        <template v-for="h in headers" v-slot:[`header.${h.value}`]>
          <span :key="h.value">
            <v-tooltip v-if="h.tooltip" :max-width="350" top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span><div v-html="h.tooltip"></div></span>
            </v-tooltip>
            <span v-else>{{ h.text }}</span>
          </span>
        </template>
        <template v-slot:item="props">
          <tr
            :id="`campaign${campaigns.indexOf(props.item)}`"
            class="cursor-pointer"
            @click="openPhonelist(props.item)"
          >
            <td>
              <v-tooltip right :key="`${props.item._id}-${props.item.status}`">
                <template v-slot:activator="{ on, attrs }">
                  <v-progress-circular
                    v-if="props.item.status === 'running'"
                    v-bind="attrs"
                    v-on="on"
                    indeterminate
                    color="primary"
                    :size="20"
                    :width="3"
                  ></v-progress-circular>
                  <v-icon
                    v-else
                    v-bind="attrs"
                    v-on="on"
                    :color="props.item.color"
                  >
                    {{ props.item.icon }}
                  </v-icon>
                </template>
                <div>
                  {{ props.item.statusText }}
                </div>
              </v-tooltip>
            </td>
            <!-- <td @click.stop="editItem(props.item)" class="p-t-5 p-b-5"> -->
            <td>
              <div class="p-t-10">
                <text-highlight :queries="handleQuery()">
                  {{ props.item.name }}
                </text-highlight>
                <progress-campaign
                  :key="props.item._id"
                  :total="props.item.total"
                  :remaining="props.item.remaining"
                />
              </div>
            </td>
            <td>{{ props.item.start_date | datetimeFormatNoTime }}</td>
            <td class="text-right">{{ props.item.total | decimalFormat }}</td>
            <td class="text-right">
              {{ props.item.remaining | decimalFormat }}
            </td>
            <td class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ props.item.percent_connect | numberToPercent }}
                  </div>
                </template>
                <span>
                  {{ props.item.connected | decimalFormat }} connected leads out
                  of
                  {{ (props.item.total - props.item.new) | decimalFormat }}
                  dialed leads
                </span>
              </v-tooltip>
            </td>
            <td class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ props.item.percent_answer | numberToPercent }}
                  </div>
                </template>
                <span>
                  {{ props.item.answered | decimalFormat }} answered leads out
                  of {{ props.item.connected | decimalFormat }} connected leads.
                </span>
              </v-tooltip>
            </td>
            <td class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ props.item.percent_convert | numberToPercent }}
                  </div>
                </template>
                <span>
                  {{ props.item.converted | decimalFormat }} conversions out of
                  {{ props.item.answered | decimalFormat }} answered leads
                </span>
              </v-tooltip>
            </td>
            <td class="text-right">
              <v-menu :absolute="true">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :id="`phone_list${campaigns.indexOf(props.item)}`"
                          class="m-l-10"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="editItem(props.item)"
                        >
                          fa-edit
                        </v-icon>
                      </template>
                      Edit
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :id="`download${campaigns.indexOf(props.item)}`"
                          class="m-l-10"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="downloadReport(props.item)"
                        >
                          fa-arrow-alt-circle-down
                        </v-icon>
                      </template>
                      Download result
                    </v-tooltip>
                    <v-menu :absolute="true">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          id="icon-dots"
                          class="p-l-10 p-r-10"
                          v-bind="attrs"
                          v-on="on"
                          small
                        >
                          fa-ellipsis-v
                        </v-icon>
                      </template>
                      <v-list dense>
                        <v-list-item @click="enableCampaign(true, props.item)">
                          <v-list-item-content>
                            <v-list-item-subtitle
                              :disabled="props.item.is_enable"
                              :class="props.item.is_enable ? 'disabled' : ''"
                              class="font-size-body"
                            >
                              Enable campaign
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="enableCampaign(false, props.item)">
                          <v-list-item-content>
                            <v-list-item-subtitle
                              :disabled="!props.item.is_enable"
                              :class="!props.item.is_enable ? 'disabled' : ''"
                              class="font-size-body"
                            >
                              Disable campaign
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="cloneItem(props.item)">
                          <v-list-item-content>
                            <v-list-item-subtitle class="font-size-body">
                              Clone campaign
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <!-- <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :id="`clone${campaigns.indexOf(props.item)}`"
                          class="m-l-10"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="cloneItem(props.item)"
                        >
                          fa-copy
                        </v-icon>
                      </template>
                      Clone
                    </v-tooltip> -->
                  </div>
                </template>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-row
      v-if="campaigns.length > 0"
      class="fix-height"
      align="center"
      justify="end"
    >
      <v-col
        class="d-flex align-center padding0 pagination"
        cols="auto"
        sm="auto"
        md="auto"
        lg="auto"
      >
        Page size
        <v-select
          id="perpage"
          class="select-item text-center m-l-10 m-r-10"
          v-model="search.limit"
          :items="$itemspage"
          item-text="title"
          item-value="value"
          no-label
          hide-details
          dense
          @input="search.limit = parseInt($event, 10)"
        ></v-select>
        Showing {{ (search.page - 1) * search.limit + 1 }} -
        {{ (search.page - 1) * search.limit + campaigns.length }} of
        {{ total | decimalFormat }}

        <v-pagination
          id="pagination"
          v-model="search.page"
          :length="totalPage"
          :total-visible="totalVisible"
          @input="next"
        ></v-pagination>
      </v-col>
    </v-row>

    <dialog-manage
      v-if="dialog"
      :rules="rules"
      :dialog="dialog"
      :action="action"
      :editedItem="editedItem"
      :errorMessage="errorMessage"
      :snackbar="snackbar"
      @close="close"
      @save="save"
    />

    <dialog-import-loading
      v-if="dialogImportLoading.open"
      :dialogImportLoading="dialogImportLoading"
    />

    <dialog-loading v-if="dialogLoading" :dialogLoading="dialogLoading" />

    <dialog-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
      @dialogConfirmClick="dialogConfirmClick"
    />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </v-container>
</template>

<script>
function arraysEqual(a1, a2) {
  /* WARNING: arrays must not contain {objects} or behavior may be undefined */
  return JSON.stringify(a1) == JSON.stringify(a2)
}

import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'
import Moment from 'moment'
import TextHighlight from 'vue-text-highlight'

import apiCampaign from '@/apis/campaign'
import csvExporter from '@/services/campaign/csv'

import DialogManage from './components/dialog_manage'
import DialogImportLoading from './components/dialog_import_loading'
import DialogLoading from './components/dialog_loading'
import DialogConfirm from './components/dialog_confirm'
import ProgressCampaign from './components/progress_campaign'
import Snackbar from './components/snackbar'

export default {
  name: 'CampaignVoice',
  props: {
    rulesCharcacters50: Object
  },
  components: {
    TextHighlight,
    DialogManage,
    DialogImportLoading,
    DialogLoading,
    DialogConfirm,
    ProgressCampaign,
    Snackbar
  },
  data() {
    return {
      reload: '',
      checkReload: [],

      word: '',
      search: {
        showActive: true,
        word: '',
        // status: '',
        sortBy: [],
        sortDesc: [],
        page: 1,
        limit: 50
      },
      loading: false,
      totalPage: 1,
      totalVisible: 7,
      total: 0,
      headers: [
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'status',
          width: '50px'
        },
        {
          text: 'Campaign name',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '300px'
        },
        {
          text: 'Schedule from',
          align: 'start',
          sortable: true,
          value: 'start_date',
          width: '150px'
        },
        {
          text: 'Total',
          align: 'right',
          sortable: true,
          value: 'total',
          width: '120px'
        },
        {
          text: 'Remaining',
          align: 'right',
          sortable: true,
          value: 'remaining',
          tooltip: 'New leads + leads to retry',
          width: '120px'
        },
        {
          text: 'Connect%',
          align: 'right',
          sortable: false,
          value: 'percent_connect',
          tooltip:
            'Percentage of connected leads / dialed leads.<br /><br />High connect rates indicate that leads are of good quality i.e. valid phone numbers.',
          width: '120px'
        },
        {
          text: 'Answer%',
          align: 'right',
          sortable: false,
          value: 'percent_answer',
          tooltip:
            'Percentage of answered leads / connected leads.<br /><br />High answer rates indicate that bots are able to call at suitable time using trust-worthy caller ID.',
          width: '120px'
        },
        {
          text: 'Convert%',
          align: 'right',
          sortable: false,
          value: 'percent_convert',
          tooltip:
            'Percentage of conversions / answered leads.<br /><br />Conversions are calls that have at least 1 successful service.',
          width: '120px'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right'
        }
      ],
      campaigns: [],
      dialog: false,
      action: 'add',
      formatDate: 'YYYY-MM-DD',
      formatTime: 'HH:mm',
      editedItem: {
        _id: '',
        name: '',
        flowId: '',
        isEnable: false,
        priorityOrder: 0,
        retryCount: 0,
        retryWithPriority: false,
        retryInterval: 10,
        maxConcurrent: 1,
        ringingTimeout: 30,
        detail: '',
        startDate: '',
        endDate: '',
        times: {
          mon: {
            text: 'Mon',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          tue: {
            text: 'Tue',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          wed: {
            text: 'Wed',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          thu: {
            text: 'Thu',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          fri: {
            text: 'Fri',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          sat: {
            text: 'Sat',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          },
          sun: {
            text: 'Sun',
            data: [
              {
                start: 540,
                end: 1080
              }
            ],
            is_expand: false,
            error: {
              time: false,
              overlap: false
            }
          }
        },
        runOnHoliday: false,
        payload: [
          {
            key: '',
            value: '',
            error: {
              status: false,
              text: ''
            }
          }
        ],
        fieldGroup: '',
        mergeCall: false,
        preCallApi: false,
        isCustomCaller: false,
        customCallerArr: [],
        methods: 'GET',
        url: '',
        headers: [{ key: 'content-type', value: 'application/json' }],
        body: '',
        setting: {
          timeout: '30.0'
        },
        postCallApi: false,
        postCallApiData: {
          methods: 'GET',
          url: '',
          headers: [{ key: 'content-type', value: 'application/json' }],
          body: '',
          setting: {
            timeout: '30.0'
          }
        }
      },
      defaultItem: {},
      errorMessage: {
        text: ''
      },
      dialogConfirm: {
        open: false,
        _id: '',
        name: ''
      },
      dialogImportLoading: {
        open: false
      },
      dialogLoading: {
        open: false,
        text: ''
      },
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.reload)
  },
  computed: {
    ...mapGetters('auth', ['show_campaign_active']),

    rules() {
      return {
        rulesCharcacters50: this.rulesCharcacters50
      }
    }
  },
  created() {
    document.title = this.$t('page-title.campaign_voice', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.editedItem.startDate = Moment()
      .startOf('day')
      .format(this.formatDate)
    this.editedItem.endDate = Moment()
      .startOf('day')
      .add(1, 'days')
      .format(this.formatDate)

    this.defaultItem = _.cloneDeep(this.editedItem)

    // get store show campaign active or not
    this.search.showActive = this.show_campaign_active

    this.initial()

    for (const property in this.search) {
      this.$watch(
        `search.${property}`, //what you want to watch
        (newVal, oldVal) => {
          if (property !== 'sortBy') {
            this.getCampaign(property)
          }

          if (property === 'showActive') {
            this.setShowCampaignActive(newVal)
          }
        }
      )
    }
  },
  methods: {
    ...mapActions('auth', ['setShowCampaignActive']),

    async initial() {
      this.setIntervalCampaign()
      await this.getCampaign()
    },

    next(page) {
      this.index = -1
    },

    setIntervalCampaign() {
      this.reload = setInterval(() => {
        this.getCampaign('page')
      }, 10000)
    },

    async getCampaign(property) {
      try {
        if (!['sortBy', 'sortDesc', 'page'].includes(property))
          this.search.page = 1

        const obj = {
          showActive: this.search.showActive,
          word: this.search.word,
          // status: this.search.status,
          // sortBy:
          //   this.search.sortBy.length !== 0
          //     ? this.search.sortBy[0]
          //     : 'created_at',
          // sortDesc:
          //   this.search.sortDesc.length !== 0 ? this.search.sortDesc[0] : true,
          sortBy:
            this.search.sortBy.length > 0
              ? this.search.sortBy
              : ['start_date', 'name'],
          sortDesc:
            this.search.sortDesc.length > 0
              ? this.search.sortDesc
              : [true, false],
          page: this.search.page,
          limit: this.search.limit
        }

        const getCampaign = await apiCampaign.getCampaign(obj)

        const { docs, totalPages, totalDocs } = getCampaign.data
        this.totalPage = totalPages
        this.total = totalDocs

        if (!arraysEqual(docs, this.checkReload)) {
          this.loading = true
          this.campaigns = JSON.parse(JSON.stringify(docs))
          this.checkReload = JSON.parse(JSON.stringify(docs))

          for (let i = 0; i < this.campaigns.length; i++) {
            // custom caller
            this.campaigns[i].customCallerArr = this.campaigns[i].custom_caller
              ? this.campaigns[i].custom_caller.split(',')
              : []
            // check status
            const { status, statusText, icon, color } = this.checkStatus(
              this.campaigns[i]
            )
            this.campaigns[i].status = status
            this.campaigns[i].statusText = statusText
            this.campaigns[i].icon = icon
            this.campaigns[i].color = color
          }

          setTimeout(() => {
            this.loading = false
          }, 500)
        }
      } catch (error) {}
    },

    handleQuery() {
      if (this.search.word) return this.search.word.split(' ')
      return []
    },
    searchWord() {
      this.search.word = this.word
    },
    clearWord() {
      this.word = ''
      this.searchWord()
    },

    openPhonelist(item) {
      // const routeData = this.$router.resolve({
      //   path: `/campaign/voice/phone_list/${item._id}`
      //   // query
      // })
      // window.open(routeData.href, '_blank')

      this.$router.push({
        path: `/campaign/voice/phone_list/${item._id}`
      })
    },

    async enableCampaign(is_enable, item) {
      // this.dialogLoading.open = true
      // if (!item.is_enable) {
      //   this.dialogLoading.text = 'Bot is going to close'
      // }

      if (is_enable) {
        if (!item.flow_ui_id) {
          this.snackbar.colorSnackbar = 'error'
          this.snackbar.textSnackbar =
            'Flow is not set. Assign a flow to campaign and try again.'
          this.snackbar.open = true

          setTimeout(() => {
            this.editItem(item)
          }, 500)

          return
        }
      }

      const obj = { is_enable }

      await apiCampaign.updateCampaignEnable(item._id, obj)

      clearInterval(this.reload)
      await this.initial()

      // this.dialogLoading.open = false
    },
    async editItem(item) {
      this.action = 'edit'
      await this.manageData(item, this.action)

      this.dialog = true
    },
    async downloadReport(item) {
      const obj = {
        id: item._id
      }
      if (process.env.VUE_APP_CAMPAIGN_NO_FIELD === 'true') {
        const writeCSV = await apiCampaign.writeCSV(obj)

        await csvExporter.exporter(writeCSV.data, 'CustomerSatisfactionReport')
      } else {
        const writeCSV = await apiCampaign.writeCommonCSV(obj)

        const name = `${item.name} - ${Moment().format('YYYY-MM-DD_HHmmss')}`
        await csvExporter.exporter(writeCSV.data, name)
      }
    },
    async cloneItem(item) {
      this.action = 'clone'
      await this.manageData(item, this.action)

      this.dialog = true
    },
    deleteItem(item) {
      this.dialogConfirm.open = true

      this.dialogConfirm._id = item._id
      this.dialogConfirm.name = item.name
    },
    async dialogConfirmClick() {
      await apiCampaign.deleteCampaign(this.dialogConfirm._id)

      this.snackbar.colorSnackbar = 'error'
      this.snackbar.textSnackbar = `${this.dialogConfirm.name} deleted`

      this.getCampaign()
      this.close()

      this.snackbar.open = true

      this.dialogConfirm.open = false

      this.dialogConfirm._id = ''
      this.dialogConfirm.name = ''
    },

    manageData(item, action) {
      this.editedItem._id = item._id

      switch (action) {
        case 'edit':
          this.editedItem.name = item.name
          break
        case 'clone':
          this.editedItem.name = `${item.name} - Copy`
          break
        default:
        // code block
      }

      this.editedItem.flowId = item.flow_ui_id
      this.editedItem.status = item.status
      this.editedItem.isEnable = item.is_enable
      this.editedItem.priorityOrder = item.priority_order
      this.editedItem.retryCount = item.retry_count
      this.editedItem.retryWithPriority = item.retry_with_priority
      this.editedItem.retryInterval = item.retry_interval
      this.editedItem.maxConcurrent = item.max_concurrent
      this.editedItem.ringingTimeout = item.ringing_timeout
      this.editedItem.detail = item.detail
      this.editedItem.startDate = item.start_date
      this.editedItem.endDate = item.end_date

      const times = {}
      for (const key in item.times) {
        if (Object.hasOwnProperty.call(item.times, key)) {
          const element = item.times[key]

          times[key] = {}
          times[key].text = key.charAt(0).toUpperCase() + key.slice(1)
          times[key].data = []
          for (let i = 0; i < element.length; i++) {
            const start = element[i].start
            let end = element[i].end

            if (i === element.length - 1 && element[i].end === 1440) {
              end = 0
            }

            times[key].data[i] = {
              start,
              end: end
            }
          }
          times[key].is_expand = false
          times[key].error = {
            time: false,
            overlap: false
          }
        }
      }
      this.editedItem.times = times

      this.editedItem.runOnHoliday = item.run_on_holiday

      const payload = []
      for (const key in item.payload) {
        if (Object.hasOwnProperty.call(item.payload, key)) {
          const value = item.payload[key]

          payload.push({
            key,
            value,
            error: {
              status: false,
              text: ''
            }
          })
        }
      }
      this.editedItem.payload =
        payload.length === 0
          ? [
              {
                key: '',
                value: '',
                error: {
                  status: false,
                  text: ''
                }
              }
            ]
          : payload

      this.editedItem.fieldGroup = item.field_group
      this.editedItem.mergeCall = item.merge_call

      // pre call api
      this.editedItem.preCallApi = item.pre_call_api
      this.editedItem.methods = item.methods || 'GET'
      this.editedItem.url = item.url
      this.editedItem.headers = item.headers || [
        { key: 'content-type', value: 'application/json' }
      ]
      this.editedItem.body = item.body
      this.editedItem.setting = item.setting || {
        timeout: '30.0'
      }

      // post call api
      this.editedItem.postCallApi = item.post_call_api
      this.editedItem.postCallApiData.methods =
        item.post_call_api_methods || 'GET'
      this.editedItem.postCallApiData.url = item.post_call_api_url
      this.editedItem.postCallApiData.headers = item.post_call_api_headers || [
        { key: 'content-type', value: 'application/json' }
      ]
      this.editedItem.postCallApiData.body = item.post_call_api_body
      this.editedItem.postCallApiData.setting = item.post_call_api_setting || {
        timeout: '30.0'
      }

      // custom caller
      this.editedItem.isCustomCaller = item.is_custom_caller
      this.editedItem.customCallerArr = item.custom_caller
        ? item.custom_caller.split(',')
        : []
    },

    close() {
      this.errorMessage.text = ''
      this.dialog = false

      this.$nextTick(() => {
        this.action = 'add'
        this.editedItem = {}
        this.editedItem = _.cloneDeep(this.defaultItem)
      })
      this.action = 'add'
      this.editedItem = {}
      this.editedItem = _.cloneDeep(this.defaultItem)
    },
    async save() {
      try {
        this.errorMessage.text = ''

        this.dialogImportLoading.open = true

        const times = {}
        for (const key in this.editedItem.times) {
          if (Object.hasOwnProperty.call(this.editedItem.times, key)) {
            times[key] = []
            const element = this.editedItem.times[key]
            for (let i = 0; i < element.data.length; i++) {
              const start = element.data[i].start
              let end = element.data[i].end

              if (i === element.data.length - 1 && element.data[i].end === 0) {
                end = 1440
              }

              times[key].push({
                start: start,
                end: end
              })
            }
          }
        }

        const payload = {}
        for (let i = 0; i < this.editedItem.payload.length; i++) {
          const key = this.editedItem.payload[i].key
          const value = this.editedItem.payload[i].value
          payload[key] = value
        }

        const obj = {}
        obj.name = this.editedItem.name
        obj.flow_ui_id = this.editedItem.flowId
        obj.is_enable = this.editedItem.isEnable
        obj.priority_order = this.editedItem.priorityOrder
        obj.retry_count = this.editedItem.retryCount
        obj.retry_with_priority = this.editedItem.retryWithPriority
        obj.retry_interval = this.editedItem.retryInterval
        obj.max_concurrent = this.editedItem.maxConcurrent
        obj.ringing_timeout = this.editedItem.ringingTimeout
        obj.detail = this.editedItem.detail
        obj.start_date = this.editedItem.startDate
        obj.end_date = this.editedItem.endDate
        obj.times = times
        obj.run_on_holiday = this.editedItem.runOnHoliday
        obj.payload = payload
        obj.field_group = this.editedItem.fieldGroup
        obj.merge_call = this.editedItem.mergeCall

        // pre call api
        obj.pre_call_api = this.editedItem.preCallApi
        obj.methods = this.editedItem.methods
        obj.url = this.editedItem.url
        obj.headers = this.editedItem.headers
        obj.body = this.editedItem.body
        obj.setting = this.editedItem.setting

        // post call api
        obj.post_call_api = this.editedItem.postCallApi
        obj.post_call_api_methods = this.editedItem.postCallApiData.methods
        obj.post_call_api_url = this.editedItem.postCallApiData.url
        obj.post_call_api_headers = this.editedItem.postCallApiData.headers
        obj.post_call_api_body = this.editedItem.postCallApiData.body
        obj.post_call_api_setting = this.editedItem.postCallApiData.setting

        // custom caller
        obj.is_custom_caller = this.editedItem.isCustomCaller
        obj.custom_caller = this.editedItem.customCallerArr.join(',')

        if (this.action === 'add') {
          const createCampaign = await apiCampaign.createCampaign(obj)

          // const routeData = this.$router.resolve({
          //   path: `/campaign/voice/phone_list/${createCampaign.campaign_id}`
          // })
          // window.open(routeData.href, '_blank')
          setTimeout(() => {
            this.$router.push({
              path: `/campaign/voice/phone_list/${createCampaign.campaign_id}`
            })
          }, 500)

          this.snackbar.textSnackbar = `${this.editedItem.name} created`
        } else if (this.action === 'edit') {
          const _id = this.editedItem._id

          await apiCampaign.updateCampaign(_id, obj)

          this.snackbar.textSnackbar = 'Changes saved'
        } else if (this.action === 'clone') {
          await apiCampaign.cloneCampaign(obj)

          this.snackbar.textSnackbar = 'Clone successed'
        }

        this.dialog = false
        this.dialogImportLoading.open = false

        this.snackbar.colorSnackbar = 'success'
        this.snackbar.open = true

        this.close()

        this.getCampaign()
      } catch (error) {
        this.dialogImportLoading.open = false

        this.errorMessage.text = error.message
      }
    },
    checkStatus(item) {
      let status = ''
      let statusText = ''
      let icon = ''
      let color = ''
      if (!item.is_enable) {
        status = 'disabled'
        statusText = 'Disabled'
        icon = 'fa-ban'
      } else if (item.remaining === 0) {
        status = 'completed'
        statusText = 'Completed'
        icon = 'far fa-check-circle'
        color = 'success'
      } else if (item.status === 'running') {
        status = 'running'
        statusText = 'Running'
      } else {
        status = 'idle'
        statusText = `Idle: ${item.note}`
        icon = 'fa-ellipsis-h'
      }

      return { status, statusText, icon, color }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  height: calc(100vh - 169px);
}

::v-deep .select-item .v-select__selection {
  color: #727272 !important;
}

::v-deep .v-input--switch {
  display: inline-block !important;
}

::v-deep .v-data-table .v-data-table__wrapper td.text-right {
  padding-right: 16px !important;
}

.select-item {
  max-width: 70px !important;
}

.disabled {
  color: $gray-color !important;
}
</style>
